export interface ImageRecord {
    image_id: string;
    /**
     * 大图
     */
    storage_path: string;
    /**
     * 缩略图
     */
    fulltext_image240_url: string;
}

export interface IOrgInfo {
    display_name?: string;
    logo?: string;
    id?: string;
    normalized_display_name?: string;
    normalized_id?: string;
    normalized_logo?: string
}

export enum SOLUTION_TYPE {
    PATENT = 'PATENT',
    PAPER = 'PAPER',
    WEBSITE = 'WEBSITE',
    NEWS = 'NEWS'
}

export enum PATENT_UPDATE_TYPE {
    /**
     * 技术被诉讼
     */
    LITIGATION = 'LITIGATION',
    /**
     * 技术被许可
     */
    LICENSE = 'LICENSE',

    LEGAL_CN = 'LEGAL_CN',
    /**
     * 法律状态变更
     */
    LEGAL = 'LEGAL',
    /**
     * 新技术公开
     */
    FPB = 'FPB',
    /**
     * 技术被引用
     */
    CITED = 'CITED',
    /**
     * 技术被无效
     */
    REEXAM = 'REEXAM',
    /**
     * 权利人变更
     */
    TRANSFER = 'TRANSFER'
}

export interface AUTHOR {
    id: string;
    name: string;
}

export enum EContentType {
    ABST = 'ABST',
    TECHNICAL_TITLE = 'TECHNICAL_TITLE'
}

export interface ISolution extends Record<string, any> {
    SOLUTION_ID: string;
    CONTENT: string;
    CONTENT_TYPE?: EContentType;
    TITLE?: string;
    ORG_INFO?: IOrgInfo[];
    APD?: string;
    SIMPLE_LEGAL_STATUS?: string | number;
    PDF_IMAGE?: ImageRecord[];
    PDF_IMAGE_COUNT?: number;
    SOLUTION_TYPE: SOLUTION_TYPE;
    PATENT_UPDATE_TS?: number | string | Date;
    PATENT_UPDATE_TYPE?: PATENT_UPDATE_TYPE
    PN?: string;
    DOI?: string;
    AUTHORS?: AUTHOR[]
    WEBSITE?: {
        name: string
        url: string
    }[]
    PUBLISH_TIME?: string
    JOURNAL?: string,
    PBD?: string
}

export interface ISolutionListResponse {
    page: number;
    limit: number;
    has_previous: boolean;
    has_next: boolean;
    total: number;
    records: ISolution[];
}
